import { render, staticRenderFns } from "./ControlButtons.vue?vue&type=template&id=f00b41ae&scoped=true&"
import script from "./ControlButtons.vue?vue&type=script&lang=ts&"
export * from "./ControlButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ControlButtons.vue?vue&type=style&index=0&id=f00b41ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00b41ae",
  null
  
)

export default component.exports